<template>
  <div class="team-page">
    <el-card class="tool-card" shadow="never">
      <div class="tool-row">
        <div class="tool-left">
          <span class="tool-title">小组管理</span>
          <span class="tool-sub">小组可独立登录账号，隶属战队；推广小组可配置推单流量</span>
        </div>
        <div class="tool-right">
          <el-select v-if="!isUnit" v-model="filterUnitId" placeholder="全部战队" clearable style="width: 180px" @change="load">
            <el-option v-for="u in units" :key="u.id" :label="u.name" :value="u.id" />
          </el-select>
          <el-button type="primary" icon="el-icon-plus" @click="openEdit(null)">新增小组</el-button>
        </div>
      </div>
    </el-card>

    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }"
        empty-text="暂无小组数据"
      >
        <el-table-column label="小组名称" min-width="140">
          <template slot-scope="{ row }">
            <div class="cell-name-main">
              <div class="cell-name-text">{{ row.name }}</div>
              <div class="cell-name-sub">{{ row.account }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="所属战队" min-width="130">
          <template slot-scope="{ row }">
            <span>{{ unitName(row.unit_id) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" min-width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="parseInt(row.type) === 2 ? 'primary' : 'warning'" size="small">{{ row.type_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="员工" min-width="70" align="center">
          <template slot-scope="{ row }">
            <span class="count-num">{{ row.staff_count }}</span>
          </template>
        </el-table-column>
        <el-table-column label="流量" min-width="80" align="center">
          <template slot-scope="{ row }">
            <span class="flow-num">{{ row.flow_count }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="parseInt(row.status) === 1 ? 'success' : 'info'" size="small">
              {{ parseInt(row.status) === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openMember(row)">组员</el-button>
            <el-button v-if="parseInt(row.type) === 1" type="text" size="small" @click="openFlow(row)">配置流量</el-button>
            <el-button type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" size="small" class="del-btn" @click="doDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑小组弹窗 -->
    <el-dialog :title="editId ? '编辑小组' : '新增小组'" :visible.sync="editVisible" width="520px">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
        <el-form-item label="所属战队" prop="unit_id">
          <el-select v-model="form.unit_id" placeholder="请选择所属战队" style="width: 100%" :disabled="isUnit" @change="onUnitChange">
            <el-option v-for="u in units" :key="u.id" :label="u.name + '（' + u.type_text + '）'" :value="u.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="登录账号" prop="account">
          <el-input v-model="form.account" placeholder="3-50 位字母数字下划线" :maxlength="50" :disabled="editId > 0" />
        </el-form-item>
        <el-form-item label="小组名称" prop="name">
          <el-input v-model="form.name" placeholder="如：推广一组" :maxlength="50" />
        </el-form-item>
        <el-form-item label="小组类型">
          <el-radio-group v-model="form.type" :disabled="editId > 0">
            <el-radio :label="1">推广小组</el-radio>
            <el-radio :label="2">销售小组</el-radio>
          </el-radio-group>
          <div v-if="!editId" class="form-hint">默认继承所属战队类型</div>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input v-model="form.password" type="password" show-password :placeholder="editId ? '不修改请留空' : '请设置登录密码'" />
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="form.contact" :maxlength="50" />
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="form.phone" :maxlength="20" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" :maxlength="200" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" active-text="启用" inactive-text="停用" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 组员管理弹窗 -->
    <el-dialog :title="'组员管理 · ' + (memberTeam ? memberTeam.name : '')" :visible.sync="memberVisible" width="560px" :close-on-click-modal="false">
      <div class="tool-row" style="margin-bottom:12px;align-items:center;">
        <span class="tool-sub">该小组下的员工（新增后自动归属本小组）</span>
        <div style="flex:1"></div>
        <el-button v-if="!showMemberForm" type="primary" size="small" icon="el-icon-plus" @click="showMemberForm = true">新增组员</el-button>
      </div>
      <!-- 新增组员表单 -->
      <div v-if="showMemberForm" class="member-add">
        <el-form ref="memberForm" :model="memberForm" :rules="memberRules" label-width="70px" size="small">
          <el-form-item label="账号" prop="account">
            <el-input v-model="memberForm.account" placeholder="登录账号（字母数字下划线）" :maxlength="50" />
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="memberForm.name" placeholder="员工姓名" :maxlength="50" />
          </el-form-item>
          <div class="addr-row">
            <el-form-item label="手机号" prop="phone" style="flex:1">
              <el-input v-model="memberForm.phone" placeholder="11 位手机号" :maxlength="11" />
            </el-form-item>
            <el-form-item label="密码" prop="password" style="flex:1">
              <el-input v-model="memberForm.password" type="password" placeholder="登录密码" :maxlength="50" />
            </el-form-item>
          </div>
        </el-form>
        <div style="text-align:right;margin-bottom:10px;">
          <el-button size="small" @click="showMemberForm = false">取 消</el-button>
          <el-button type="primary" size="small" :loading="memberSaving" @click="doAddMember">保存组员</el-button>
        </div>
      </div>
      <el-table v-loading="memberLoading" :data="memberList" :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }" empty-text="该小组暂无组员">
        <el-table-column label="组员" min-width="150">
          <template slot-scope="{ row }">
            <div class="cell-name-main">
              <div class="cell-name-text">
                {{ row.name }}
                <el-tag v-if="parseInt(row.is_leader) === 1" type="warning" size="mini" effect="plain">队长</el-tag>
              </div>
              <div class="cell-name-sub">{{ row.account }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="类型" min-width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="parseInt(row.type) === 2 ? 'primary' : 'success'" size="small">{{ row.type_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="parseInt(row.status) === 1 ? 'success' : 'info'" size="small">{{ parseInt(row.status) === 1 ? '启用' : '停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" class="del-btn" @click="doDelMember(row)">移出</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 配置流量弹窗：把销售员工配置到本推广小组，实现销售获取推广 -->
    <el-dialog :title="'配置流量 · ' + (flowTeam ? flowTeam.name : '')" width="680px" :visible.sync="flowVisible">
      <div class="flow-tip">
        把<strong>销售员工</strong>勾选到本推广小组，即可接收该小组推送的推广线索；可设每人每日接单上限、是否参与分配。
      </div>
      <div v-loading="flowLoading" class="flow-body">
        <div v-if="saleStaffs.length === 0" class="empty-row">暂无销售战队员工可选</div>
        <div v-else>
          <div class="flow-head">
            <span class="flow-head-col">销售员工</span>
            <span class="flow-head-col">参与轮询</span>
          </div>
          <div v-for="s in saleStaffs" :key="s.id" class="flow-item" :class="{ 'flow-item-off': !flowMap[s.id] || !flowMap[s.id].status }">
            <span class="flow-col flow-staff">
              <span class="flow-staff-name">{{ s.name }}</span>
              <span class="flow-staff-sub">{{ s.account }}</span>
            </span>
            <span class="flow-col">
              <el-switch v-model="flowMap[s.id].status" />
            </span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="flowVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="flowSaving" @click="doFlowSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { teamList, teamSave, teamDelete, unitList, staffList, staffSave, staffDelete, flowList, flowSave } from '@/api/org'

export default {
  name: 'TeamList',
  data() {
    return {
      list: [],
      units: [],
      filterUnitId: null,
      loading: false,
      editVisible: false,
      editId: 0,
      saving: false,
      form: { unit_id: null, account: '', name: '', type: 2, password: '', contact: '', phone: '', remark: '', status: true },
      rules: {
        unit_id: [{ required: true, message: '请选择所属战队', trigger: 'change' }],
        account: [
          { required: true, message: '请填写登录账号', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]{3,50}$/, message: '3-50 位字母数字下划线', trigger: 'blur' }
        ],
        name: [{ required: true, message: '请填写小组名称', trigger: 'blur' }],
        password: [{ validator: (r, v, cb) => { if (this.editId === 0 && !v) cb(new Error('请设置登录密码')); else cb() }, trigger: 'blur' }]
      },
      // 配置流量
      flowVisible: false,
      flowLoading: false,
      flowSaving: false,
      flowTeam: null,
      saleStaffs: [],
      flowMap: {},
      // 组员管理
      memberVisible: false,
      memberLoading: false,
      memberSaving: false,
      memberTeam: null,
      memberList: [],
      showMemberForm: false,
      memberForm: { account: '', name: '', phone: '', password: '' },
      memberRules: {
        account: [
          { required: true, message: '请填写登录账号', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]{3,50}$/, message: '3-50 位字母数字下划线', trigger: 'blur' }
        ],
        name: [{ required: true, message: '请填写员工姓名', trigger: 'blur' }],
        phone: [{ pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' }],
        password: [{ required: true, message: '请设置登录密码', trigger: 'blur' }]
      }
    }
  },
  computed: {
    isUnit() {
      const u = this.$store.state.user
      return !!u && u.type === 'unit'
    },
    selfUnitId() {
      const u = this.$store.state.user
      return u ? parseInt(u.id) : 0
    },
    selfType() {
      const u = this.$store.state.user
      return u ? parseInt(u.unit_type) : 2
    }
  },
  created() {
    this.loadUnits()
    this.load()
  },
  methods: {
    loadUnits() {
      // 战队长：只归属本战队，直接锁定自身，不拉全站战队
      if (this.isUnit) {
        const u = this.$store.state.user
        this.units = [{ id: parseInt(u.id), name: (u && u.name) || '本战队', type: this.selfType || 2 }]
        this.filterUnitId = parseInt(u.id)
        return
      }
      unitList()
        .then(data => { this.units = data.list || [] })
        .catch(() => {})
    },
    load() {
      this.loading = true
      teamList({ unit_id: this.filterUnitId || 0 })
        .then(data => { this.list = data.list || [] })
        .catch(() => { this.list = [] })
        .finally(() => { this.loading = false })
    },
    unitName(unitId) {
      const u = this.units.find(x => parseInt(x.id) === parseInt(unitId))
      return u ? u.name : '—'
    },
    onUnitChange() {
      if (!this.form.unit_id) return
      const u = this.units.find(x => parseInt(x.id) === parseInt(this.form.unit_id))
      if (u) this.form.type = parseInt(u.type)
    },
    openEdit(row) {
      if (row) {
        this.editId = row.id
        this.form = {
          unit_id: parseInt(row.unit_id),
          account: row.account,
          name: row.name,
          type: parseInt(row.type),
          password: '',
          contact: row.contact || '',
          phone: row.phone || '',
          remark: row.remark || '',
          status: parseInt(row.status) === 1
        }
      } else {
        this.editId = 0
        this.form = { unit_id: this.isUnit ? this.selfUnitId : null, account: '', name: '', type: this.isUnit ? this.selfType : 2, password: '', contact: '', phone: '', remark: '', status: true }
      }
      this.editVisible = true
    },
    doSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        teamSave({
          id: this.editId,
          unit_id: this.form.unit_id,
          account: this.form.account,
          name: this.form.name,
          type: this.form.type,
          password: this.form.password,
          contact: (this.form.contact || '').trim(),
          phone: (this.form.phone || '').trim(),
          remark: (this.form.remark || '').trim(),
          status: this.form.status ? 1 : 0
        })
          .then(() => {
            this.$message.success(this.editId ? '修改成功' : '新增成功')
            this.editVisible = false
            this.load()
          })
          .catch(() => {})
          .finally(() => { this.saving = false })
      })
    },
    /* ===== 组员管理 ===== */
    openMember(row) {
      this.memberTeam = row
      this.memberVisible = true
      this.showMemberForm = false
      this.memberForm = { account: '', name: '', phone: '', password: '' }
      this.loadMembers()
    },
    loadMembers() {
      if (!this.memberTeam) return
      this.memberLoading = true
      staffList({ team_id: this.memberTeam.id })
        .then(data => { this.memberList = data.list || [] })
        .catch(() => { this.memberList = [] })
        .finally(() => { this.memberLoading = false })
    },
    doAddMember() {
      if (!this.memberTeam) return
      this.$refs.memberForm.validate(valid => {
        if (!valid) return
        this.memberSaving = true
        staffSave({
          unit_id: this.memberTeam.unit_id,
          team_id: this.memberTeam.id,
          account: this.memberForm.account.trim(),
          name: this.memberForm.name.trim(),
          phone: (this.memberForm.phone || '').trim(),
          password: this.memberForm.password
        })
          .then(() => {
            this.$message.success('组员新增成功')
            this.showMemberForm = false
            this.memberList = []
            this.memberForm = { account: '', name: '', phone: '', password: '' }
            this.loadMembers()
            this.load()
          })
          .catch(() => {})
          .finally(() => { this.memberSaving = false })
      })
    },
    doDelMember(row) {
      if (!this.memberTeam) return
      this.$confirm(`确认将员工「${row.name}」移出本小组？`, '移出组员', {
        confirmButtonText: '移 出',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        staffDelete(row.id)
          .then(() => {
            this.$message.success('已移出')
            this.loadMembers()
            this.load()
          })
          .catch(() => {})
      }).catch(() => {})
    },
    doDelete(row) {
      this.$confirm(`确认删除小组「${row.name}」？`, '删除小组', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        teamDelete(row.id)
          .then(() => {
            this.$message.success('删除成功')
            this.load()
          })
          .catch(() => {})
      }).catch(() => {})
    },
    /* ===== 配置流量 ===== */
    openFlow(row) {
      this.flowTeam = row
      this.flowVisible = true
      this.flowLoading = true
      // 加载销售战队员工 + 本小组已有配置
      Promise.all([this.loadSaleStaffs(), flowList(row.id)])
        .then(([staffsData, flowData]) => {
          const flowMap = {}
          ;(flowData.list || []).forEach(f => {
            flowMap[f.staff_id] = {
              daily_limit: parseInt(f.daily_limit) || 0,
              sort: parseInt(f.sort) || 0,
              status: parseInt(f.status) === 1
            }
          })
          this.saleStaffs.forEach(s => {
            if (!flowMap[s.id]) {
              flowMap[s.id] = { daily_limit: 0, sort: 0, status: false }
            }
          })
          this.flowMap = flowMap
        })
        .finally(() => { this.flowLoading = false })
    },
    loadSaleStaffs() {
      // 战队长：仅本战队销售员工（staffList 后端已限定本战队）
      if (this.isUnit) {
        return staffList({}).then(ds => {
          this.saleStaffs = (ds.list || []).filter(s => parseInt(s.type) === 2 && parseInt(s.status) === 1)
          return { list: this.saleStaffs }
        })
      }
      return unitList().then(du => {
        const saleUnitIds = (du.list || []).filter(u => parseInt(u.type) === 2).map(u => parseInt(u.id))
        return staffList({}).then(ds => {
          this.saleStaffs = (ds.list || []).filter(s => saleUnitIds.indexOf(parseInt(s.unit_id)) > -1 && parseInt(s.status) === 1)
          return { list: this.saleStaffs }
        })
      })
    },
    doFlowSave() {
      const items = this.saleStaffs.map(s => ({
        staff_id: s.id,
        daily_limit: this.flowMap[s.id] ? this.flowMap[s.id].daily_limit : 0,
        sort: this.flowMap[s.id] ? this.flowMap[s.id].sort : 0,
        status: (this.flowMap[s.id] && this.flowMap[s.id].status) ? 1 : 0
      }))
      this.flowSaving = true
      flowSave({ team_id: this.flowTeam.id, items })
        .then(() => {
          this.$message.success('流量配置已保存')
          this.flowVisible = false
          this.load()
        })
        .catch(() => {})
        .finally(() => { this.flowSaving = false })
    }
  }
}
</script>

<style scoped>
.team-page { padding: 0; }

.tool-card {
  margin-bottom: 14px;
  border-radius: 10px;
  border: 1px solid #E5E9F2;
}

.tool-row { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; }
.tool-left { display: flex; align-items: baseline; gap: 12px; }
.tool-right { display: flex; gap: 10px; }
.tool-title { font-size: 15px; font-weight: 700; color: #18233C; }
.tool-sub { font-size: 12px; color: #8A94AD; }

.table-card { border-radius: 10px; border: 1px solid #E5E9F2; }

.cell-name-main { min-width: 0; }
.cell-name-text { display: block; font-size: 13px; font-weight: 600; color: #18233C; }
.cell-name-sub { display: block; font-size: 11px; color: #8A94AD; margin-top: 2px; font-family: monospace; }
.count-num { font-size: 14px; font-weight: 600; color: #3668FC; }
.flow-num { font-size: 14px; font-weight: 600; color: #E8930C; }
.del-btn { color: #E5484D; }
.form-hint { margin-top: 6px; font-size: 12px; color: #8A94AD; }
.addr-row { display: flex; gap: 10px; }
.member-add {
  background: #F7F9FC;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 12px;
}

/* 配置流量 */
.flow-tip {
  background: #EDF3FE;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 12px;
  color: #3668FC;
  margin-bottom: 12px;
}

.flow-body { max-height: 400px; overflow-y: auto; }

.flow-head {
  display: grid;
  grid-template-columns: 2fr 0.8fr;
  gap: 10px;
  padding: 8px 12px;
  background: #F7F9FC;
  border-radius: 8px 8px 0 0;
  font-size: 12px;
  font-weight: 600;
  color: #8A94AD;
}

.flow-item {
  display: grid;
  grid-template-columns: 2fr 0.8fr;
  gap: 10px;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #F2F4F8;
}

.flow-item:hover { background: #FAFBFF; }
.flow-item-off { opacity: 0.55; }

.flow-staff { display: flex; flex-direction: column; }
.flow-staff-name { font-size: 13px; font-weight: 600; color: #18233C; }
.flow-staff-sub { font-size: 11px; color: #8A94AD; font-family: monospace; }

.empty-row {
  padding: 30px 0;
  text-align: center;
  font-size: 12px;
  color: #B4BDCF;
}

/* ===== Element UI 品牌色统一 ===== */
::v-deep .el-button--primary { background: #3668FC; border-color: #3668FC; }
::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }
::v-deep .el-table__row:hover > td { background: #F5F8FF !important; }
::v-deep .el-dialog { border-radius: 12px; }
</style>